import { render, staticRenderFns } from "./ComponentMatterResponsible.vue?vue&type=template&id=534d9041"
import script from "./ComponentMatterResponsible.vue?vue&type=script&lang=js"
export * from "./ComponentMatterResponsible.vue?vue&type=script&lang=js"
import style0 from "./ComponentMatterResponsible.vue?vue&type=style&index=0&id=534d9041&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports